<template>
  <v-list-tile :style="active ? {backgroundColor: 'rgb(220,220,220)'} : null" @click="navigate()">
    <v-list-tile-action v-if="item.icon">
      <v-icon :color="item.iconColor">{{ item.icon }}</v-icon>
    </v-list-tile-action>
    <v-list-tile-content>
      <v-list-tile-title>
        <span v-if="item.id">{{ $t(`mainComponent.${item.id}`) }}</span>
        <span v-else>{{ item.text }}</span>
      </v-list-tile-title>
    </v-list-tile-content>
  </v-list-tile>
</template>

<script>
export default {
  name: 'DrawerListItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
    active: Boolean,
    shiftRight: Boolean,
  },
  methods: {
    navigate() {
      this.$emit('onNavigate');
    },
  },
};
</script>
